// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"218be987","453":"8a8071a2","455":"3e0d11bc","884":"379ec319"}[chunkId] + ".chunk.js";
};